/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import type { ThemeType } from "@packages/ui";
import { InlineIcon, numericPercentages, spacing, Text } from "@packages/ui";

import type { MetaData } from "../../lib";

const metaDataContainerStyles: Interpolation = {
  alignItems: "center",
  display: "flex",
  gap: spacing.xs,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  width: numericPercentages[100],
};

const metaDataTextStyles: Interpolation<ThemeType> = (theme: ThemeType) => ({
  color: theme.semanticColors.neutralsMedium,
});

const metaDataIconContainerStyles: Interpolation<ThemeType> = (
  theme: ThemeType,
) => ({
  color: theme.semanticColors.neutralsLower,
  flexShrink: 0,
});

const contentTextStyles: Interpolation = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  width: numericPercentages[100],
};

export const ContentItemMetaData = ({ text, icon }: MetaData) => (
  <div css={metaDataContainerStyles}>
    {icon && (
      <div css={metaDataIconContainerStyles}>
        <InlineIcon icon={icon} />
      </div>
    )}
    <Text type="detail" size="l" css={[contentTextStyles, metaDataTextStyles]}>
      {text}
    </Text>
  </div>
);
